const state = {
  selected: {},
  allIrpfReports: [],
  irpfMessage: ''
}
const actions = {
  async getIrpfReportsList({ commit, dispatch, state }, plan) {
    let cpf = plan.beneficiarios[0].cpf
    let _this = this
    let query = {}
    let irpfMessage = ''
    let allIrpfReports = []

    // let obj = {
    //   url: `/boletos/?tipo=irpf&cpf=${cpf}&ey=${_this.state.ey}`,
    //   query: query,
    //   method: 'get',
    //   api:'irpf'
    // }
    // {
    //   "cpf": "99999999999",
    //     "kw": "xxxxxxxxxxxxxxx"
    // }
    let obj = {
      //url: '/corpore/wscorp.dll/datasnap/rest/tsmadesao/cobrancas',
      url: '/getListInform',
      query: { cpf: cpf, kw: localStorage.corporeToken },
      method: 'post'
    }
    await _this.dispatch('request/doRequest', obj).then(resp => {
      console.log('aq')
      if (resp && resp.data.documentos.length) {
        //let paramsList = ['cpf', 'nome', 'ano', 'operadora', 'entidade', 'proposta', 'codigo']
        resp.data.documentos.map(line => {
          let lineObj = {
            cpf: line.cpfTitular,
            nome: line.nomeTitular,
            ano: line.anoCalendario,
            operadora: line.nomeOperadora,
            entidade: "",
            proposta: line.numeroProposta,
            codigo: line.codigo
          }
          allIrpfReports.push(lineObj)
          // dispatch('convertArryToObject', { line, paramsList }).then(lineObj =>
          //   allIrpfReports.push(lineObj)
          // )
        })
      } else {
        irpfMessage = 'IRPF não encontrado'
      }
    })
    commit('saveIrpfReports', { irpfMessage, allIrpfReports })
    return true
  },
  convertArryToObject({ }, { ...params }) {
    let obj = params.line.reduce((acum, current, i) => {
      acum[params.paramsList[i]] = current
      return acum
    }, {})
    return obj
  },
}

const mutations = {
  saveIrpfReports: (state, irpf) => {
    console.log('kkkk', irpf.allIrpfReports)
    if (irpf.irpfMessage) {
      state.irpfMessage = irpf.irpfMessage
    }
    if (irpf.allIrpfReports) {
      state.allIrpfReports = irpf.allIrpfReports
    }
  }
}

export default {
  namespaced: true,
  root: true,
  actions,
  mutations,
  state
}
